import { useEffect, useState } from "react";
import "./styles/index.scss";

const TabSelector = ({ tabs, onTabChange, activeTab = null }) => {
  // const [activeTab, setActiveTab] = useState(initialActiveTab ? initialActiveTab : tabs?.[0]?.anchor || '');

  // console.log('ini', initialActiveTab, 'tabs', tabs)
  // const [activeTab, setActiveTab] = useState(
  //   initialActiveTab ? initialActiveTab : tabs?.[0]?.anchor || ''
  // );

  // Notifica il tab attivo al genitore solo dopo il primo render
  // useEffect(() => {
  //   if (onTabChange && typeof onTabChange === 'function') {
  //     onTabChange(activeTab);
  //   }
  // }, [activeTab, onTabChange]);


  const handleTabClick = (anchor) => {
    // setActiveTab(anchor);
    onTabChange(anchor); // Restituisce l'anchor attivo al padre
  };

  return (
    <div className="tab-selector">
      {tabs.map((tab) => (
        <div
          key={tab.anchor}
          className={`tab ${activeTab === tab.anchor ? 'active' : ''}`}
          onClick={() => handleTabClick(tab.anchor)}
        >
          {tab.name}
        </div>
      ))}
    </div>
  );
};

export default TabSelector;
